import { useTranslation } from 'react-i18next';

import useGetUuid from 'components/accountSettings/utils';
import { Button } from 'components/buttons';
import { Panel } from 'components/containers';
import IconCross from 'components/icons/cross';
import { Buttons, Delimeter, ModalControls } from 'components/modal/styles';

import { TopupModalContent } from './content';
import { LABELS } from './keys';
import { ModalContent, StyledDialog } from './styles';

interface TopUpModalProps {
  isOpen: boolean;
  toggle: () => void;
}

const TopUpModal = ({ isOpen, toggle }: TopUpModalProps) => {
  const { t } = useTranslation();
  const merchantUuid = useGetUuid() ?? '';

  return (
    <StyledDialog open={isOpen} scroll="body" disableEscapeKeyDown fullWidth>
      <Panel
        label={t(LABELS.TITLE)}
        controls={
          <ModalControls>
            <Button flat onClick={toggle}>
              <IconCross />
            </Button>
          </ModalControls>
        }
      >
        <TopupModalContent merchantUuid={merchantUuid} />
        <ModalContent>
          <Delimeter />
          <Buttons>
            <Button secondary onClick={toggle}>
              {t(LABELS.ACTIONS.CANCEL)}
            </Button>
            <Button primary onClick={toggle}>
              {t(LABELS.ACTIONS.DONE)}
            </Button>
          </Buttons>
        </ModalContent>
      </Panel>
    </StyledDialog>
  );
};

export default TopUpModal;
